import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';

import { Page } from '../enums/page.enum';
import * as readOnlyActions from './read-only.actions';

export interface State {
  pageReadonlyStates: Record<Page, boolean>;
}

const initialState: State = {
  pageReadonlyStates: {
    [Page.Tables]: false,
    [Page.Processes]: false,
    [Page.Issues]: false,
    [Page.Reports]: false,
  },
};

export const pageReadOnlyReducer = createReducer(
  initialState,
  on(readOnlyActions.setReadOnlyPageState, (state: State, { page, isReadOnlyState }) => ({
    ...state,
    pageReadonlyStates: {
      ...state.pageReadonlyStates,
      [page]: isReadOnlyState,
    },
  })),
);

const selectFeatureState = createFeatureSelector<State>('readOnly');

export const selectPageReadonlyState = createSelector(selectFeatureState, (state: State) => (page: Page) => state.pageReadonlyStates[page]);
